import { render, staticRenderFns } from "./ViewSite.vue?vue&type=template&id=64c455b6&"
import script from "./ViewSite.vue?vue&type=script&lang=js&"
export * from "./ViewSite.vue?vue&type=script&lang=js&"
import style0 from "./ViewSite.vue?vue&type=style&index=0&id=64c455b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports